import React, { useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import './DateTimeRangePicker.scss';

/** @param {import('rsuite').DateRangePickerProps & {hasError: boolean}} param0 */
const DateTimeRangePicker = ({
    hasError,
    character,
    value: controlledValue,
    ...props
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { DateTimeFormat: dateTimeFormat } = JSON.parse(sessionStorage.getItem('jwtUserInfo') || '{}');
    
    let defaultDateTimeFormat = dateTimeFormat ? `${dateTimeFormat.LongDateFormat} ${dateTimeFormat.TimeFormat}` : 'yyyy-MM-dd HH:mm aa';
    const isMeridiem = !defaultDateTimeFormat.includes('aa') && defaultDateTimeFormat.includes('a');
    if (isMeridiem) {
        defaultDateTimeFormat = defaultDateTimeFormat.replace('a', 'aa');
    }

    const handleOpenMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }

    const calendarIcon = React.forwardRef((iconProps, ref) => {
        return (
            <FontAwesomeIcon
                className="date-time-picker-caret-icon"
                icon={faCalendarDays} 
                {...iconProps} 
                ref={ref}
            />)
    });

    const chevronIcon = isMenuOpen ? faChevronUp : faChevronDown;

    return (
        <div className={`core--date-time-range-picker ${hasError ? 'core--date-time-range-picker-error' : ''}`}>
            <DateRangePicker
                menuClassName="core--date-time-range-picker-menu"
                character={character || ' - '}
                format={defaultDateTimeFormat}
                caretAs={calendarIcon}
                showHeader={false}
                showMeridiem={isMeridiem}
                onOpen={() => setIsMenuOpen(true)}
                onOk={() => setIsMenuOpen(false)}
                onExit={() => setIsMenuOpen(false)}
                open={isMenuOpen}
                value={controlledValue?.filter((date) => date !== null)}
                {...props}
            />
            <div
                className="date-time-range-picker-chevron-icon-wrapper"
                onClick={handleOpenMenu}
            >
                <FontAwesomeIcon icon={chevronIcon} />
            </div>
            {isMenuOpen && (
                <div
                    className="core--date-time-range-picker-overlay"
                    onClick={() => setIsMenuOpen(false)}
                >
                </div>
            )}
        </div>
    );
};

export default DateTimeRangePicker;
